import React, { Context, ReactNode, useContext } from 'react';
import { SortDirection } from '../../../../../config/constants';
import {
    ActiveSortType,
    EmissionSpoolsType,
    SortKey,
} from '../../../../../context/emissionSpools/emissionSpoolsType';

type Props = {
    dataKey: SortKey;
    variant?: string;
    withSort?: boolean;
    children: ReactNode;
    context: Context<EmissionSpoolsType>;
};

const EmissionSpoolsTableHeader: React.FC<Props> = ({
    dataKey,
    children,
    variant = 'default',
    withSort = true,
    context,
}) => {
    const { handleSortClick, activeSort } = useContext(context);

    const sort = (dataKey: SortKey, activeSort: ActiveSortType, withSort: boolean) => {
        if (!withSort) return;

        handleSortClick(dataKey, activeSort);
    };

    return (
        <div
            className={`table-header ${variant === 'filter' ? 'filter' : ''}`}
            onClick={() => sort(dataKey, activeSort, withSort)}
        >
            {children}

            {withSort ? (
                <div className='arrow-container'>
                    <div
                        className={`arrow-up ${
                            activeSort?.key === dataKey &&
                            activeSort?.direction === SortDirection.DESC
                                ? 'active'
                                : ''
                        }`}
                    />
                    <div
                        className={`arrow-down ${
                            activeSort?.key === dataKey &&
                            activeSort?.direction === SortDirection.ASC
                                ? 'active'
                                : ''
                        }`}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default EmissionSpoolsTableHeader;
